module.exports = __webpack_public_path__ + "img/calendar-minus.f50a03bd.svg";